import { Component, OnInit, OnDestroy, signal, Signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { interval, Subscription, takeUntil, Subject, catchError, of } from 'rxjs';
import { prodAPI } from '../../../env';
import { UserEntry } from '../../models/user.model';
import { MinutesToHmPipe } from '../pipes/secondsToHm.pipe';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [CommonModule, MinutesToHmPipe],
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
  private stopPolling$ = new Subject<void>();
  private pollingSubscription?: Subscription;

  public readonly users: WritableSignal<UserEntry[]> = signal<UserEntry[]>([]);
  public readonly isLoading: WritableSignal<boolean> = signal<boolean>(true);

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.startUsersPolling();
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  private startUsersPolling(intervalTime: number = 9000): void {
    this.fetchUsers();

    this.pollingSubscription = interval(intervalTime)
      .pipe(
        takeUntil(this.stopPolling$)
      )
      .subscribe(() => {
        this.fetchUsers();
      });
  }

  private fetchUsers(): void {
    this.isLoading.set(true);
    
    this.http.get<UserEntry[]>(`${prodAPI}/api/overlay/leaderboard`)
      .pipe(
        catchError((err) => {
          console.error('Error fetching users:', err);
          return of([]);
        })
      )
      .subscribe({
        next: (users) => {
          if (users && users.length > 0) {
            this.users.set(users);
          } else {
            
          }
          this.isLoading.set(false);
        },
        error: () => {
          const mockUsers: UserEntry[] = [
            // {
            //   username: 'thisisabignicknametotest',
            //   type: 'user',
            //   is_youtube: true,
            //   is_twitch: true,
            //   time: '+22h55m'
            // },
            // {
            //   username: 'gypsyartist618',
            //   type: 'user',
            //   is_youtube: false,
            //   is_twitch: true,
            //   time: '+12h31m'
            // },
            // {
            //   username: 'streamer123',
            //   type: 'user',
            //   is_youtube: true,
            //   is_twitch: false,
            //   time: '+8h45m'
            // },
            // {
            //   username: 'gamerpro',
            //   type: 'user',
            //   is_youtube: false,
            //   is_twitch: true,
            //   time: '+6h20m'
            // },
            // {
            //   username: 'contentcreator',
            //   type: 'user',
            //   is_youtube: true,
            //   is_twitch: true,
            //   time: '+4h15m'
            // }
          ];
          
          this.users.set(mockUsers);
          this.isLoading.set(false);
        }
      });
  }

  private stopPolling(): void {
    this.stopPolling$.next();
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = undefined;
    }
  }

  getDisplayUsers(): UserEntry[] {
    const displayUsers: UserEntry[] = [];
  
    for (let i = 0; i < 15; i++) {
      if (i < this.users().length) {
        displayUsers.push(this.users()[i]);
      } else {
        displayUsers.push({
          username: '',
          type: 'user',
          is_youtube: false,
          is_twitch: false,
          time: ''
        });
      }
    }
    
    return displayUsers;
  }

  getPlatformIcon(user: UserEntry): string {
    if (user.is_youtube && user.is_twitch) {
      return 'both';
    } else if (user.is_youtube) {
      return 'youtube';
    } else if (user.is_twitch) {
      return 'twitch';
    }
    return 'default';
  }

  getPlatformClass(user: UserEntry): string {
    if (user.is_youtube && user.is_twitch) {
      return 'platform-both';
    } else if (user.is_youtube) {
      return 'platform-youtube';
    } else if (user.is_twitch) {
      return 'platform-twitch';
    }
    return 'platform-default';
  }

  trackByUsername(index: number, user: UserEntry): string {
    return user.username;
  }

  formatTime(user: UserEntry): string {
    if (user.time) {
      return user.time;
    }
    
    const hours = Math.floor(Math.random() * 24);
    const minutes = Math.floor(Math.random() * 60);
    
    if (hours === 0) {
      return `+${minutes}m`;
    } else if (minutes === 0) {
      return `+${hours}h`;
    } else {
      return `+${hours}h${minutes}m`;
    }
  }
}
